import { Dot } from '@phosphor-icons/react';
import { Loader, VText } from '@vake/ui-kit';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { useIsUser } from '../requests/reports';
import { useVesselNameSearch } from '../requests/search';
import { mmsiToFlag } from '../utils/mmsi-to-flag';

const SearchComponent: React.FC = () => {
    const { token } = useAuth();
    const { data: isUser } = useIsUser(token);
    const [searchInput, setSearchInput] = useState('');
    const { data: searchResults = [], isLoading, isError, refetch } = useVesselNameSearch(searchInput);
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const cleanedInput = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
        setSearchInput(cleanedInput);
    };
    useEffect(() => {
        const delay = 300;
        const timeoutId = setTimeout(() => {
            refetch();
        }, delay);

        return () => clearTimeout(timeoutId);
    }, [searchInput, refetch]);

    if (isError || !isUser) {
        return (
            <div className="flex items-center justify-center h-screen w-fill bg-background-primary">
                <VText>Fetching data failed</VText>
            </div>
        );
    }
    return (
        <div className="flex flex-col items-center text-center justify-center h-screen w-fill bg-background-primary gap-1">
            <input
                className="p-2 text-base border border-gray-300 rounded text-label-quaternary"
                type="text"
                value={searchInput}
                onChange={handleInputChange}
                placeholder="Enter your search term"
            ></input>
            <div>Flag - Name - MMSI - IMO</div>
            {isLoading && <Loader size={24} />}
            {searchResults.map((result, i) => {
                return (
                    <div className="p-2 border rounded flex items-center" key={i}>
                        <VText>{mmsiToFlag(result.mmsi)}</VText>
                        <VText>
                            <Dot />
                        </VText>
                        <VText>{result.name}</VText>
                        <VText>
                            <Dot />
                        </VText>
                        <VText>{result.mmsi}</VText>
                        <VText>
                            <Dot />
                        </VText>
                        <VText>{result.imo}</VText>
                    </div>
                );
            })}
            {searchResults.length === 0 && !isLoading && <VText>No results found for the given search term.</VText>}
        </div>
    );
};

export default SearchComponent;
